import React, { useState } from 'react';
import { Mail, Phone, MapPin, Send, Instagram, Clock } from 'lucide-react';
import Header from './components/Header13';
import Footer from './components/Footer13';

const Contact13 = () => {
    const [formData, setFormData] = useState({ name: '', email: '', subject: '', message: '' });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setFormData({ name: '', email: '', subject: '', message: '' });
    };

    const inputStyle = {
        width: '100%', padding: '14px 16px', border: '1px solid #E7E0D6', borderRadius: '4px',
        backgroundColor: '#FBF8F4', fontFamily: "'Mulish', sans-serif", fontSize: '14px',
        color: '#1C1917', outline: 'none', transition: 'border-color 0.3s',
    };

    const contactInfo = [
        { icon: Phone, label: 'Call Us', value: '+91 98765 43210', sub: 'Mon-Sat, 10am-7pm' },
        { icon: Mail, label: 'Email', value: 'hello@karigar.in', sub: 'We reply within 24 hours' },
        { icon: MapPin, label: 'Visit', value: 'Craft Village, Jaipur', sub: 'Rajasthan 302001' },
        { icon: Clock, label: 'Hours', value: 'Mon - Sat: 10am - 7pm', sub: 'Sunday: Closed' },
    ];

    return (
        <>
            <style>{`@import url('https://fonts.googleapis.com/css2?family=Merriweather:wght@400;700&family=Mulish:wght@300;400;600&display=swap');`}</style>
            <div style={{ fontFamily: "'Mulish', sans-serif" }} className="min-h-screen bg-[#FBF8F4]">
                <Header />
                <main style={{ paddingTop: '72px' }}>
                    {/* Hero */}
                    <div style={{ backgroundColor: '#F7F3ED', padding: '48px 20px', textAlign: 'center', borderBottom: '1px solid #E7E0D6' }} className="md:py-20">
                        <p style={{ fontSize: '12px', letterSpacing: '4px', color: '#C2410C', textTransform: 'uppercase', fontWeight: 600, marginBottom: '12px' }}>Get in Touch</p>
                        <h1 style={{ fontFamily: "'Merriweather', Georgia, serif", fontSize: '32px', fontWeight: 700, color: '#1C1917', marginBottom: '12px' }} className="md:text-5xl">Contact Us</h1>
                        <p style={{ fontSize: '15px', color: '#78716C', maxWidth: '500px', margin: '0 auto' }}>
                            We would love to hear from you. Whether it is about our crafts, custom orders, or collaborations.
                        </p>
                    </div>

                    <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '60px 20px 80px' }}>
                        <div className="lg:grid lg:grid-cols-2 lg:gap-16">
                            {/* Contact Info */}
                            <div style={{ marginBottom: '48px' }} className="lg:mb-0">
                                <h2 style={{ fontFamily: "'Merriweather', Georgia, serif", fontSize: '24px', fontWeight: 700, color: '#1C1917', marginBottom: '24px' }}>Reach Out</h2>
                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                                    {contactInfo.map((item, i) => (
                                        <div key={i} style={{ backgroundColor: '#F7F3ED', borderRadius: '8px', padding: '24px', border: '1px solid #E7E0D6' }}>
                                            <item.icon size={24} style={{ color: '#C2410C', marginBottom: '12px' }} />
                                            <h3 style={{ fontSize: '14px', fontWeight: 600, color: '#1C1917', marginBottom: '4px' }}>{item.label}</h3>
                                            <p style={{ fontSize: '14px', color: '#1C1917', marginBottom: '2px' }}>{item.value}</p>
                                            <p style={{ fontSize: '12px', color: '#78716C' }}>{item.sub}</p>
                                        </div>
                                    ))}
                                </div>

                                <div style={{ marginTop: '32px' }}>
                                    <h3 style={{ fontSize: '14px', fontWeight: 600, color: '#1C1917', marginBottom: '12px' }}>Follow Our Craft Journey</h3>
                                    <div style={{ display: 'flex', gap: '10px' }}>
                                        {[Instagram, Mail].map((Icon, i) => (
                                            <a key={i} href="#" style={{
                                                width: '40px', height: '40px', borderRadius: '50%', border: '1px solid #E7E0D6',
                                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                                                color: '#C2410C', transition: 'all 0.3s',
                                            }}
                                            onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#C2410C'; e.currentTarget.style.color = '#FFF'; e.currentTarget.style.borderColor = '#C2410C'; }}
                                            onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; e.currentTarget.style.color = '#C2410C'; e.currentTarget.style.borderColor = '#E7E0D6'; }}>
                                                <Icon size={18} />
                                            </a>
                                        ))}
                                    </div>
                                </div>
                            </div>

                            {/* Contact Form */}
                            <div>
                                <h2 style={{ fontFamily: "'Merriweather', Georgia, serif", fontSize: '24px', fontWeight: 700, color: '#1C1917', marginBottom: '24px' }}>Send a Message</h2>
                                <form onSubmit={handleSubmit}>
                                    {[
                                        { name: 'name', type: 'text', placeholder: 'Your Name' },
                                        { name: 'email', type: 'email', placeholder: 'Your Email' },
                                        { name: 'subject', type: 'text', placeholder: 'Subject' },
                                    ].map(field => (
                                        <div key={field.name} style={{ marginBottom: '16px' }}>
                                            <input name={field.name} type={field.type} value={formData[field.name]} onChange={handleInputChange} placeholder={field.placeholder} style={inputStyle}
                                                onFocus={(e) => { e.target.style.borderColor = '#C2410C'; }} onBlur={(e) => { e.target.style.borderColor = '#E7E0D6'; }} />
                                        </div>
                                    ))}
                                    <div style={{ marginBottom: '24px' }}>
                                        <textarea name="message" value={formData.message} onChange={handleInputChange} placeholder="Your message..." rows={5}
                                            style={{ ...inputStyle, resize: 'vertical', minHeight: '120px' }}
                                            onFocus={(e) => { e.target.style.borderColor = '#C2410C'; }} onBlur={(e) => { e.target.style.borderColor = '#E7E0D6'; }} />
                                    </div>
                                    <button type="submit"
                                        style={{
                                            width: '100%', padding: '16px', backgroundColor: '#C2410C', color: '#FFFFFF',
                                            border: 'none', borderRadius: '4px', fontSize: '13px', fontWeight: 600,
                                            letterSpacing: '1.5px', textTransform: 'uppercase', cursor: 'pointer',
                                            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px',
                                            minHeight: '52px', transition: 'all 0.3s',
                                        }}
                                        onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#9A3412'; }}
                                        onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = '#C2410C'; }}>
                                        <Send size={16} /> Send Message
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </main>
                <Footer />
            </div>
        </>
    );
};

export default Contact13;
